"use client";
import { apiGetData, apiPostData, apiPostDataJson, axiosApiCalling } from "api";
import { useAuthContext } from "auth/hooks";
import { useTranslate } from "locales";
import { useSnackbar } from "notistack";
import PropTypes from "prop-types";
import { createContext, useState } from "react";
import { useRouter } from "routes/hooks";
import { ADMIN_RESTRICTED, FORCE_PUCNH_IN, INTERNET_NETWORK_ERROR, NOT_COMPANY_SET, SA_RESTRICTED, SESSION_EXPIRED, TIMEOUT } from "utils/constant";
import { APP_NAME } from "../config-global";

const ApiContext = createContext({
    apiCalling: () => Promise.resolve(),
    getApiData: () => Promise.resolve(),
});

ApiProvider.propTypes = {
    children: PropTypes.node,
};

function ApiProvider({ children }) {
    const { t } = useTranslate();
    const router = useRouter();
    const { enqueueSnackbar } = useSnackbar();
    const { logout, user } = useAuthContext();
    const companyID = user?.currentWorkshop?.company_id;

    const [punchInModal, setPunchInModal] = useState(false);
    function punchInModalClose(value) {
        setPunchInModal(false);
        value.update && window.location.reload()
    }
    async function apiCalling(requestObject) {
        const { showToast = true, method = 'GET' } = requestObject;
        try {
            const response = await axiosApiCalling(requestObject);
            const message = response?.data?.message;
            (!!message && message != 'Success') && enqueueSnackbar(message, { variant: "success" });
            return response;
        } catch (error) {
            if (error instanceof Blob) {
                const errorText = await error.text();
                const errorJson = JSON.parse(errorText)
                checkError(errorJson, showToast, method == 'GET');
            } else {
                checkError(error, showToast, method == 'GET');
            }
            throw error;
        }
    }

    async function postApiData(url, data = {}, showToast = true) {
        try {
            const response = await apiPostData(url, data);
            return response;
        } catch (error) {
            checkError(error);
            throw error;
        }
    }

    async function postJsonApiData(url, data = {}, showToast = true) {
        try {
            const response = await apiPostDataJson(url, data);
            return response;
        } catch (error) {
            checkError(error);
            throw error;
        }
    }

    async function getApiData(url, params = '', signal = "", showToast = true, requestId) {
        if (companyID) {
            try {
                const response = await apiGetData(url, params, signal);
                return response;
            } catch (error) {
                checkError(error, showToast, true);
                throw error;
            }
        } else {
            handleLogout()
        }
    }
    const handleLogout = async () => {
        try {
            await logout();
            router.replace("/");
        } catch (error) {
            console.error(error);
            enqueueSnackbar("Unable to logout!", { variant: "error" });
        }
    };
    function checkError(error, showToast = true, isGetMethod = false) {
        if (error.message == TIMEOUT) {
            enqueueSnackbar(t("error_slow_internet_connection"), { variant: "error" });
        } else if (error.message == INTERNET_NETWORK_ERROR) {
            enqueueSnackbar(t("error_internet_connection", { placeholder: APP_NAME }), { variant: "error" });
        } else {
            if (error.status == SESSION_EXPIRED) {
                handleLogout();
            }
            else if (error.status == NOT_COMPANY_SET) {
                enqueueSnackbar(error.message || t('error_something_went_wrong'), { variant: "error" })
            }
            else if (error.status == SA_RESTRICTED || error.status == ADMIN_RESTRICTED) {
                if (isGetMethod) {
                    showToast && enqueueSnackbar(error.message || t('error_something_went_wrong'), { variant: "error" })
                } else {
                    enqueueSnackbar(error.message || t('error_something_went_wrong'), { variant: "error" })
                }

            }
            else if (error.status == FORCE_PUCNH_IN) {
                setPunchInModal(true);//WHEN PUNCH IN REQUIRE FOR ACCESS THEN OPEN PUNCHIN DIALOG OPEN
                !isGetMethod && enqueueSnackbar(error.message || t('error_something_went_wrong'), { variant: "error" })
            } else {
                (error.message != "canceled" && showToast) && enqueueSnackbar(error.message || t('error_something_went_wrong'), { variant: "error" });
            }
        }
    }
    return (
        <ApiContext.Provider
            value={{
                apiCalling,
                getApiData,
                postApiData,
                postJsonApiData
            }}
        >

            {children}
        </ApiContext.Provider>
    );
}
export { ApiContext, ApiProvider };
